import { forwardRef } from 'react'
import type { SelectHTMLAttributes } from 'react'

import { cn } from '@/lib/cn'

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, children, ...props },
  ref,
) {
  return (
    <select
      ref={ref}
      className={cn(
        'block w-full rounded-xl border border-white/10 bg-white/5 px-4 py-2 text-sm text-white shadow-inner focus:border-brand-400 focus:outline-none focus:ring-2 focus:ring-brand-400/60',
        className,
      )}
      {...props}
    >
      {children}
    </select>
  )
})
